module.exports = require("/opt/build/repo/src/reducers/createStore")